var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaisses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation_Building_04",
    "data-name": "Navigation / Building_04",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2,20H4m0,0H14M4,20V6.2a4.971,4.971,0,0,1,.218-2.108,2,2,0,0,1,.874-.874A4.971,4.971,0,0,1,7.2,3h3.6a4.964,4.964,0,0,1,2.107.218,2,2,0,0,1,.875.874A4.962,4.962,0,0,1,14,6.2V12m0,8h6m-6,0V12m6,8h2m-2,0V12a4.986,4.986,0,0,0-.152-1.765,2,2,0,0,0-1.082-1.083A4.991,4.991,0,0,0,17,9a4.988,4.988,0,0,0-1.765.152,2,2,0,0,0-1.082,1.083A4.987,4.987,0,0,0,14,12M7,10h4M7,7h4",
    fill: "none",
    stroke: "#9a9a9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaisses);
export default __webpack_public_path__ + "static/media/caisses.373ad21e7d8794a684caf87fbd592aac.svg";
export { ForwardRef as ReactComponent };